class PropertyTable {
    constructor(propertyListComponent) {
        if (!(propertyListComponent instanceof HTMLElement)) {
            throw new TypeError("The element must be an HTML element.");
        }
        
        this.propertyListComponent = propertyListComponent;
    }

    populateTable(propertyData) {
        const headings = propertyData.headings;
        const dataItems = propertyData.items;
        const configuration = propertyData.configuration;
        const tableWrapper = this.propertyListComponent.querySelector('.table-wrapper');
        const table = document.createElement('table');
        table.setAttribute('class', 'pagination');
        tableWrapper.appendChild(table);

        for (const field in propertyData) {
            const tableHead = document.createElement('thead');
            const tableRow = document.createElement('tr');
            tableHead.appendChild(tableRow);
            const tableBody = document.createElement('tbody');
            if (field === 'headings') {
                for (const heading in headings) {
                    const tableColumnHeading = document.createElement('th');
                    tableRow.appendChild(tableColumnHeading);
                    tableColumnHeading.innerText = headings[heading];
                    table.appendChild(tableHead);
                }
                //for buttons
                const tableColumnHeading = document.createElement('th');
                tableColumnHeading.classList.add('disabled-sorting');
                tableRow.appendChild(tableColumnHeading);
                table.appendChild(tableHead);
            } else if (field === 'items') {
                for (const dataItem in dataItems) {
                    const tableRow = document.createElement('tr');
                    let item = dataItems[dataItem].fields;
                    let btn = dataItems[dataItem].button;
                    for (const row in item) {
                        const tableData = document.createElement('td');
                        tableRow.appendChild(tableData);
                        tableBody.appendChild(tableRow);
                        table.appendChild(tableBody);
                        if (row === 'propertynumber') {
                            if (btn.url !== '') {
                                let link = document.createElement('a');
                                link.setAttribute('href', btn.url);
                                link.innerHTML = item[row];
                                link.setAttribute('class', 'link--default');
                                link.setAttribute('title', btn.tooltip);
                                tableData.appendChild(link);
                            } else {
                                tableData.innerText = item[row];
                            }
                        }
                        else {
                            tableData.innerText = item[row];
                        }
                    }

                    if (btn.url !== '') {
                        let link = document.createElement('a');
                        link.setAttribute('href', btn.url);
                        link.innerHTML = btn.name;
                        link.setAttribute('class', 'button button--primary');
                        link.setAttribute('title', btn.name);
                        let NEW_CELL = tableRow.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    } else {
                        let link = document.createElement('span');
                        link.innerHTML = btn.name;
                        let NEW_CELL = tableRow.insertCell(-1);
                        NEW_CELL.appendChild(link);
                    }
                }
            }
        }
        const dataTable = tableUtils.initPaginatedDataTable(tableWrapper, configuration, false, true);
        if (dataItems === undefined || dataItems.length == 0) {
            let ERROR_MSG = document.createElement('span');
            ERROR_MSG.innerText = configuration.headerTemplateMessage;
            ERROR_MSG.setAttribute('class', 'no-items');
            this.propertyListComponent.appendChild(ERROR_MSG);
            let TABLE_WRAP = document.querySelector('.table-wrapper');
            TABLE_WRAP.style.display = 'none';
            dataTable.destroy();
        } else {
            let paginationWrapper = tableWrapper.querySelector('.dataTable-pagination');
            if (paginationWrapper && paginationWrapper.hasChildNodes()) {
                tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
                tableUtils.displayFirstPageAfterSort(dataTable, tableWrapper);
            }
        }
    }
}